import React from 'react'
import PropTypes from 'prop-types'
import { Cell } from 'fixed-data-table-2'
import classnames from 'classnames/bind'
import DataTableUtils from '../utils'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

const HtmlCell = props => {
  const { rowIndex, definition, data, ...restProps } = props
  const { field } = definition
  const baseField = field.substring(field.lastIndexOf('.') + 1)
  const row = data[rowIndex]
  return (
    <Cell
      data-elm-id={`${baseField}_${rowIndex}_cell`}
      className={cx('cell')}
      {...restProps}
    >
      <div
        data-elm-id={`${baseField}_${rowIndex}_value`}
        style={{
          width: DataTableUtils.getCellInnerWidth(definition.colProps),
        }}
        className={cx('text-truncate', 'html-cell')}
        dangerouslySetInnerHTML={{ __html: row[baseField] }}
      />
    </Cell>
  )
}

HtmlCell.propTypes = {
  rowIndex: PropTypes.number,
  definition: PropTypes.object.isRequired,
  data: PropTypes.array,
}

export default HtmlCell
